import { useState, useCallback } from 'react';
import { filterAcceptedFiles } from '../utils/fileUtils';

export const useDragAndDrop = (handleMultipleUploads) => {
  const [dragActive, setDragActive] = useState(false);

  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  }, []);

  const handleDrop = useCallback(async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    const files = e.dataTransfer?.files;
    if (files && files.length > 0) {
      const acceptedFiles = filterAcceptedFiles(files);

      if (acceptedFiles.length > 0) {
        await handleMultipleUploads(acceptedFiles);
      }
    }
  }, [handleMultipleUploads]);

  return { dragActive, handleDrag, handleDrop };
};
